export default {
  title: "Secrets & Integrations",
  subtitle:
    "API keys and secrets shared across modules. Values encrypted at rest (AES-256-GCM); never returned in cleartext by the API.",
  createCta: "Create secret",
  createTitle: "New secret",
  createDescription:
    "The name identifies the secret in templates; the connector type filters by consumer.",
  filterPlaceholder: "Filter by type",
  allConnectors: "All connectors",
  empty: "No secret for this connector yet.",
  created: "Secret created.",
  createFailed: "Create failed.",
  fetchFailed: "Could not load the secret list.",
  revoke: "Revoke",
  revoked: "Secret revoked.",
  revokeFailed: "Revoke failed.",
  revokeTitle: "Revoke this secret?",
  revokeMessage:
    '"{name}" can no longer be used by connectors. The row stays visible as revoked.',
  deleted: "Secret deleted.",
  deleteFailed: "Delete failed.",
  deleteTitle: "Delete this secret?",
  deleteMessage: '"{name}" will be permanently deleted. This cannot be undone.',
  nameLabel: "Technical name",
  connectorLabel: "Connector type",
  valueLabel: "Value",
  descriptionLabel: "Description",
  descriptionPlaceholder: 'Optional. e.g. "LRE prod AR24"',
  columns: {
    name: "Name",
    connector: "Connector",
    description: "Description",
    status: "Status",
    updated: "Updated",
    actions: "",
  },
  connectors: {
    lre_api: "LRE (registered letter)",
    smtp: "SMTP",
    openai: "OpenAI",
    jira: "Jira",
    notion: "Notion",
    other: "Other",
  },
  picker: {
    loading: "Loading…",
    createCta: "Create new secret",
    cancel: "Cancel",
    save: "Save secret",
    nameLabel: "Name",
    descriptionLabel: "Description (optional)",
    docsHint: "Need one?",
    docsLink: "Get your {label}",
    usedBy: "Used by {count} agent",
    usedByPlural: "Used by {count} agents",
    generateCta: "Generate a strong random value",
    generateHint:
      'Or click "Generate" above to have the server mint a cryptographically strong random value.',
    revealTitle: "Secret created — copy it now",
    revealBody:
      "This value is shown exactly once. After you dismiss this panel it cannot be retrieved.",
    revealValueLabel: "Generated value",
    revealDismiss: "I've copied it",
    copy: "Copy to clipboard",
  },
};
